import { Instagram } from "lucide-react";

const VIDEOS = ["7685476145654926612", "7685886489959402772", "7688033029117250836"];

export const Watch = () => (
  <section id="watch" className="bg-sand text-ink py-24 md:py-32" data-testid="watch-section">
    <div className="max-w-6xl mx-auto px-6">
      <div className="flex flex-wrap items-end justify-between gap-6 fr-reveal">
        <div className="min-w-0">
          <p className="font-mono fr-lbl">Watch / @riseandshiny_</p>
          <h2 className="font-mono font-bold fr-h2 mt-2">Family, in practice</h2>
        </div>
        <div className="flex flex-wrap gap-6 font-mono fr-lbl">
          <a href="https://www.tiktok.com/@riseandshiny_" target="_blank" rel="noopener noreferrer" className="border-b-2 border-ink pb-1 hover:text-rose hover:border-rose transition-colors duration-200" data-testid="watch-tiktok-link">
            More on TikTok
          </a>
          <a href="https://www.instagram.com/riseandshiny_/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 border-b-2 border-ink pb-1 hover:text-rose hover:border-rose transition-colors duration-200" data-testid="watch-instagram-link">
            <Instagram size={16} /> Follow on Instagram
          </a>
        </div>
      </div>
      <div className="mt-12 grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-sm lg:max-w-none mx-auto">
        {VIDEOS.map((id, i) => (
          <div key={id} className="fr-reveal border-4 border-ink bg-ink shadow-[8px_8px_0_0_#e07a9b] aspect-[9/16] overflow-hidden" style={{ transitionDelay: `${i * 80}ms` }} data-testid={`watch-video-${i + 1}`}>
            <iframe
              src={`https://www.tiktok.com/player/v1/${id}?music_info=0&description=0&rel=0`}
              title={`Video ${i + 1} from @riseandshiny_ on TikTok`}
              loading="lazy"
              allow="encrypted-media; fullscreen; picture-in-picture"
              allowFullScreen
              className="h-full w-full"
            />
          </div>
        ))}
      </div>
    </div>
  </section>
);
